const initialState = {
  username: '',
  uuid: '',
  tokenType: 'Bearer',
  isLoggedIn: false,
  token: '',
  role: '',
  name: '',
  loadProjectDetailPending: false,
  loadProjectDetailError: null,
  projectDetail: null,
  hideProjectWelcomePopupPending: false,
  hideProjectWelcomePopupError: null,
  showProjectWelcomePopup: true,
  addLastAccessPending: false,
  addLastAccessError: null,
};

export default initialState;
